jQuery(".m-social__options a").bind("click",function(e){
    options = jQuery(this).attr("href");
    jQuery(options).toggleClass("js-m-social__share--isactive");
    e.preventDefault();
});